var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMascotCollaborate1Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 73,
    viewBox: "0 0 90 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6375 58.8421C39.6316 58.8421 40.4375 59.648 40.4375 60.6419V70.0919V70.5419C40.4375 71.5361 39.6316 72.3419 38.6375 72.3419H38.1875H37.7375H33.6875C32.4448 72.3419 31.4375 71.3345 31.4375 70.0919C31.4375 68.8493 32.4448 67.8419 33.6875 67.8419H35.0375C35.5345 67.8419 35.9375 67.4393 35.9375 66.9419V60.6419C35.9375 59.648 36.7434 58.8421 37.7375 58.8421H38.6375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4211 58.8421C50.427 58.8421 49.6211 59.648 49.6211 60.6419V70.0919V70.5419C49.6211 71.5361 50.427 72.3419 51.4211 72.3419H51.8711H52.3211H56.3711C57.6138 72.3419 58.6211 71.3345 58.6211 70.0919C58.6211 68.8493 57.6138 67.8419 56.3711 67.8419H55.0211C54.5241 67.8419 54.1211 67.4393 54.1211 66.9419V60.6419C54.1211 59.648 53.3152 58.8421 52.3211 58.8421H51.4211Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4994 13.3351C79.4988 13.3351 79.4988 13.3348 79.4988 13.3344C79.4994 13.2946 79.5 13.2546 79.5 13.2146V5.81289C79.5 2.10435 75.8478 -0.500523 72.3414 0.707324L46.8071 9.50325C45.6691 9.89523 44.4326 9.89583 43.2943 9.50481L17.6541 0.698466C14.1487 -0.505527 10.5 2.09915 10.5 5.80563V13.3351V17.1159V42.5813C10.5 44.0725 9.29118 45.2813 7.8 45.2813H4.56C2.04158 45.2813 0 47.3229 0 49.8413C0 52.3597 2.04158 54.4013 4.56 54.4013H85.44C87.9582 54.4013 90 52.3597 90 49.8413C90 47.3229 87.9582 45.2813 85.44 45.2813H82.2C80.709 45.2813 79.5 44.0725 79.5 42.5813V13.3357C79.5 13.3354 79.5 13.3351 79.4994 13.3351Z",
    fill: "#5775FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5008 36.3413H79.5008V42.5813C79.5008 44.0725 80.7098 45.2813 82.2008 45.2813H7.80078C9.29196 45.2813 10.5008 44.0725 10.5008 42.5813V36.3413Z",
    fill: "#FFBC57"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6107_3007",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 18,
    width: 18,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27.3413C45 22.3707 40.9706 18.3413 36 18.3413C31.0294 18.3413 27 22.3707 27 27.3413V36.3413C27 41.3119 31.0294 45.3413 36 45.3413C40.9706 45.3413 45 41.3119 45 36.3413V27.3413Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6107_3007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 27.3413C45 22.3707 40.9706 18.3413 36 18.3413C31.0294 18.3413 27 22.3707 27 27.3413V36.3413C27 41.3119 31.0294 45.3413 36 45.3413C40.9706 45.3413 45 41.3119 45 36.3413V27.3413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6983 28.2962C36.5694 28.7152 36.5 29.1601 36.5 29.6213V34.1213C36.5 36.6066 38.5147 38.6213 41 38.6213C43.4853 38.6213 45.5 36.6066 45.5 34.1213V29.6213C45.5 27.1361 43.4853 25.1213 41 25.1213C40.5388 25.1213 40.0938 25.1907 39.6749 25.3196C40.4562 25.6724 41 26.4584 41 27.3713C41 28.614 39.9927 29.6213 38.75 29.6213C37.837 29.6213 37.051 29.0776 36.6983 28.2962Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6107_3007",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 18,
    width: 18,
    height: 28
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27.3413C63 22.3707 58.9706 18.3413 54 18.3413C49.0294 18.3413 45 22.3707 45 27.3413V36.3413C45 41.3119 49.0294 45.3413 54 45.3413C58.9706 45.3413 63 41.3119 63 36.3413V27.3413Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6107_3007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 27.3413C63 22.3707 58.9706 18.3413 54 18.3413C49.0294 18.3413 45 22.3707 45 27.3413V36.3413C45 41.3119 49.0294 45.3413 54 45.3413C58.9706 45.3413 63 41.3119 63 36.3413V27.3413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6633 28.3556C54.5569 28.7393 54.5 29.1437 54.5 29.5613V34.093C54.5 36.5783 56.5147 38.593 59 38.593C61.4853 38.593 63.5 36.5783 63.5 34.093V29.5613C63.5 27.076 61.4853 25.0613 59 25.0613C58.5688 25.0613 58.1518 25.1219 57.757 25.2352C58.4941 25.6046 59 26.3671 59 27.2477V27.5125C59 28.7551 57.9927 29.7625 56.75 29.7625C55.8055 29.7625 54.997 29.1805 54.6633 28.3556Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotCollaborate1Fill);
export default __webpack_public_path__ + "static/media/mascot-collaborate-1-fill.10a409c517c8de97d335a95ed29c2627.svg";
export { ForwardRef as ReactComponent };